import React from "react";
import '../stylesheets/comingSoon.scss'

class ComingSoon extends React.Component {
    render() {
        return (
            <div className="coming-soon">
                <div>
                    <h1 className="text1">COMING SOON</h1>
                    <h3 className="uc">Under Construction!</h3>
                </div>
            </div>
        )
    }
}

export default ComingSoon